module.exports = __webpack_public_path__ + "static/media/icon-login-partners.2c3a590a.svg";